import { render, staticRenderFns } from "./PrintTransactionSandogh.vue?vue&type=template&id=c0607474&scoped=true&"
import script from "./PrintTransactionSandogh.vue?vue&type=script&lang=js&"
export * from "./PrintTransactionSandogh.vue?vue&type=script&lang=js&"
import style0 from "./PrintTransactionSandogh.vue?vue&type=style&index=0&id=c0607474&scoped=true&lang=css&"
import style1 from "./PrintTransactionSandogh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0607474",
  null
  
)

export default component.exports